import script from "./PagosTab.vue?vue&type=script&setup=true&lang=js"
export * from "./PagosTab.vue?vue&type=script&setup=true&lang=js"

import "./PagosTab.vue?vue&type=style&index=0&id=02bc99de&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-02bc99de"]])

export default __exports__